<template lang="pug">
  .single-date-picker
    label.date-label Select a date
    el-date-picker(
      v-model="internalValue"
      type="datetime"
      :picker-options="pickerOptions"
      format="dd/MM/yyyy HH:mm"
      :placeholder="'date'"
      :default-value="new Date()"
      @change="emitChangeEvent"
    )
</template>

<script>
export default {
  name: "SingleDateTimePicker",

  props: {
    value: {
      type: [String, Date],
      default: () => new Date(),
    },
    resetSignal: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      internalValue: this.value,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60000; // disables past datetimes
        }
      }
    };
  },

  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },

    internalValue(newVal) {
      this.$emit("input", newVal);
    },

    resetSignal() {
      this.internalValue = new Date();
      this.$emit("input", this.internalValue);
      this.emitChangeEvent(this.internalValue);
    }
  },

  methods: {
    emitChangeEvent(value) {
      if (!value || new Date(value).getTime() <= Date.now()) {
        this.$emit("invalid", "Selected time must be in the future.");
        return;
      }

      // Send local Date object instead of UTC string
      this.$emit("onChange", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.single-date-picker {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .date-label {
    font-weight: 500;
    font-size: 14px;
    color: #606266;
    margin-bottom: 4px;
  }

  .el-date-editor {
    width: 240px;
  }
}
</style>